<template>
  <div
    :style="{
      position: 'absolute',
      bottom: '-700px',
      left: 'calc(50% - 258px)',
      width: '530px',
      height: '108px',
      fontSize: '22px',
      color: 'rgba(255, 255, 255, 0.9)',
      fontFamily: 'PingFang SC',
    }"
  >
    <div
      :style="{
        position: 'absolute',
        top: 'calc(50% - 49px)',
        left: 'calc(50% - 265px)',
        borderRadius: '21px',
        backgroundColor: 'rgba(5, 24, 33, 0.9)',
        backdropFilter: 'blur(13.4px)',
        width: '530px',
        height: '98px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '12px 32px',
        boxSizing: 'border-box',
        gap: '28px',
      }"
    >
      <!-- <div
        :style="{
          flex: '1',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '12px',
        }"
      > -->
      <!-- <div
          :style="{
            borderRadius: '12px',
            backgroundColor: 'rgba(40, 252, 246, 0.02)',
            boxShadow: '0px 0px 14.1px rgba(48, 198, 201, 0.3) inset',
            width: '72px',
            height: '72px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
          }"
        >
          <img
            :style="{
              position: 'relative',
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }"
            alt=""
            src="@/assets/images/photovoltaic/dian.png"
          />
        </div> -->
      <!-- <div
          :style="{
            flex: '1',
            borderRadius: '4px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
            gap: '16px',
          }"
        >
          <div :style="{ position: 'relative', lineHeight: '30px' }">
            累计碳减排（kg）
          </div>
          <div
            :style="{
              position: 'relative',
              fontSize: '32px',
              lineHeight: '18px',
              fontFamily: 'Eurostile LT Std',
              color: '#c0fbf8',
            }"
          >
            {{ list.carbon_emission_reduction }}
          </div>
        </div> -->
      <!-- </div> -->
      <div
        :style="{
          flex: '1',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '12px',
        }"
      >
        <div
          :style="{
            borderRadius: '12px',
            backgroundColor: 'rgba(40, 252, 246, 0.02)',
            boxShadow: '0px 0px 14.1px rgba(48, 198, 201, 0.3) inset',
            width: '72px',
            height: '72px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
          }"
        >
          <img
            :style="{
              position: 'relative',
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }"
            alt=""
            src="@/assets/images/photovoltaic/wang.png"
          />
        </div>
        <div
          :style="{
            flex: '1',
            borderRadius: '4px',
            display: 'flex',
            fontSize: '16px',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
            gap: '14px',
          }"
        >
          <div :style="{ position: 'relative', lineHeight: '30px' }">养护里程（km）</div>
          <div
            :style="{
              position: 'relative',
              fontSize: '28px',
              lineHeight: '18px',
              fontFamily: 'Eurostile LT Std',
              color: '#c0fbf8',
            }"
          >
            15115
            <!-- {{ list.equivalent_planting }} -->
          </div>
        </div>
      </div>
      <div
        :style="{
          flex: '1',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '12px',
        }"
      >
        <div
          :style="{
            borderRadius: '12px',
            backgroundColor: 'rgba(40, 252, 246, 0.02)',
            boxShadow: '0px 0px 14.1px rgba(48, 198, 201, 0.3) inset',
            width: '72px',
            height: '72px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
          }"
        >
          <img
            :style="{
              position: 'relative',
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }"
            alt=""
            src="@/assets/images/photovoltaic/qian.png"
          />
        </div>
        <div
          :style="{
            flex: '1',
            borderRadius: '4px',
            display: 'flex',
            fontSize: '16px',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
            gap: '16px',
          }"
        >
          <div :style="{ position: 'relative', lineHeight: '30px' }">
            节约成本（万元）
          </div>
          <div
            :style="{
              position: 'relative',
              fontSize: '28px',
              lineHeight: '18px',
              fontFamily: 'Eurostile LT Std',
              color: '#c0fbf8',
            }"
          >
            451
            <!-- {{ list.sulfur_abatement }} -->
          </div>
        </div>
      </div>
    </div>
    <img
      :style="{
        position: 'absolute',
        top: 'calc(50% - 54px)',
        left: '0px',
        width: '26px',
        height: '108px',
        objectFit: 'cover',
      }"
      alt=""
      src="https://sass.gclme.com/api/file/Image/annex/20231228_36c7048fa003472098341fd32ef1a1c2.png"
    />
    <img
      :style="{
        position: 'absolute',
        top: 'calc(50% - 54px)',
        right: '0px',
        width: '26px',
        height: '108px',
        objectFit: 'cover',
      }"
      alt=""
      src="https://sass.gclme.com/api/file/Image/annex/20231228_82d3a67c92614ceab706f7d083afe831.png"
    />
  </div>
</template>

<script>
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  components: {},
  data() {
    return {
      list: {},
      query: this.$route.query,
    };
  },
  mounted() {
    this.initData();
  },
  destroyed() {},
  methods: {
    initData() {
      let cityCode = this.query.province || this.query.city || "000000";
      let params = {
        enCode: "zngf-qg-zjzbtj", // 接口code
        // 接口传参
        "@adcode": cityCode,
      };
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          console.log("累计收益 res:", res);
          this.list = res[0] || {};
        })
        .catch((err) => {
          console.log("累计收益 err:", err);
        });
    },
    format(item) {
      if (item) return item.split(".")[0];
      return item;
    },
  },
};
</script>
